/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDiaglabEquipments } from 'app/entities/diaglab-equipment/diaglab-equipment.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getDiaglabBills } from 'app/entities/diaglab-bill/diaglab-bill.reducer';
import { getEntities as getRadiologyPricings } from 'app/entities/radiology-pricing/radiology-pricing.reducer';
import { getEntities as getRadiologyStudies } from 'app/entities/radiology-study/radiology-study.reducer';
import { getEntities as getPaymentSchemes } from 'app/entities/payment-scheme/payment-scheme.reducer';
import { ProcedurePriority } from 'app/shared/model/enumerations/procedure-priority.model';
import { createEntity, getEntity, reset, updateEntity } from './radiology-bill-item.reducer';

export const RadiologyBillItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const diaglabEquipments = useAppSelector(state => state.diaglabEquipment.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const diaglabBills = useAppSelector(state => state.diaglabBill.entities);
  const radiologyPricings = useAppSelector(state => state.radiologyPricing.entities);
  const radiologyStudies = useAppSelector(state => state.radiologyStudy.entities);
  const paymentSchemes = useAppSelector(state => state.paymentScheme.entities);
  const radiologyBillItemEntity = useAppSelector(state => state.radiologyBillItem.entity);
  const loading = useAppSelector(state => state.radiologyBillItem.loading);
  const updating = useAppSelector(state => state.radiologyBillItem.updating);
  const updateSuccess = useAppSelector(state => state.radiologyBillItem.updateSuccess);
  const procedurePriorityValues = Object.keys(ProcedurePriority);

  const handleClose = () => {
    navigate(`/radiology-bill-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDiaglabEquipments({}));
    dispatch(getDoctors({}));
    dispatch(getDiaglabBills({}));
    dispatch(getRadiologyPricings({}));
    dispatch(getRadiologyStudies({}));
    dispatch(getPaymentSchemes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.price !== undefined && typeof values.price !== 'number') {
      values.price = Number(values.price);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.scheduledTime !== undefined && typeof values.scheduledTime !== 'number') {
      values.scheduledTime = Number(values.scheduledTime);
    }
    if (values.paidAmount !== undefined && typeof values.paidAmount !== 'number') {
      values.paidAmount = Number(values.paidAmount);
    }

    const entity = {
      ...radiologyBillItemEntity,
      ...values,
      scheduledAt: diaglabEquipments.find(it => it.id.toString() === values.scheduledAt?.toString()),
      performedBy: doctors.find(it => it.id.toString() === values.performedBy?.toString()),
      referTo: doctors.find(it => it.id.toString() === values.referTo?.toString()),
      diaglabBill: diaglabBills.find(it => it.id.toString() === values.diaglabBill?.toString()),
      radiologyPricing: radiologyPricings.find(it => it.id.toString() === values.radiologyPricing?.toString()),
      radiologyStudy: radiologyStudies.find(it => it.id.toString() === values.radiologyStudy?.toString()),
      scheme: paymentSchemes.find(it => it.id.toString() === values.scheme?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          procedurePriority: 'STAT',
          ...radiologyBillItemEntity,
          scheduledAt: radiologyBillItemEntity?.scheduledAt?.id,
          performedBy: radiologyBillItemEntity?.performedBy?.id,
          referTo: radiologyBillItemEntity?.referTo?.id,
          diaglabBill: radiologyBillItemEntity?.diaglabBill?.id,
          radiologyPricing: radiologyBillItemEntity?.radiologyPricing?.id,
          radiologyStudy: radiologyBillItemEntity?.radiologyStudy?.id,
          scheme: radiologyBillItemEntity?.scheme?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.radiologyBillItem.home.createOrEditLabel" data-cy="RadiologyBillItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.radiologyBillItem.home.createOrEditLabel">Create or edit a RadiologyBillItem</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="radiology-bill-item-id"
                  label={translate('tinyMedicRestApp.radiologyBillItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyBillItem.price')}
                id="radiology-bill-item-price"
                name="price"
                data-cy="price"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyBillItem.discount')}
                id="radiology-bill-item-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyBillItem.active')}
                id="radiology-bill-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyBillItem.cursor')}
                id="radiology-bill-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyBillItem.lastupdated')}
                id="radiology-bill-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyBillItem.microSec')}
                id="radiology-bill-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyBillItem.timestampentry')}
                id="radiology-bill-item-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyBillItem.statusCode')}
                id="radiology-bill-item-statusCode"
                name="statusCode"
                data-cy="statusCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyBillItem.accessionNo')}
                id="radiology-bill-item-accessionNo"
                name="accessionNo"
                data-cy="accessionNo"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyBillItem.scheduledTime')}
                id="radiology-bill-item-scheduledTime"
                name="scheduledTime"
                data-cy="scheduledTime"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyBillItem.procedurePriority')}
                id="radiology-bill-item-procedurePriority"
                name="procedurePriority"
                data-cy="procedurePriority"
                type="select"
              >
                {procedurePriorityValues.map(procedurePriority => (
                  <option value={procedurePriority} key={procedurePriority}>
                    {translate(`tinyMedicRestApp.ProcedurePriority.${procedurePriority}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.radiologyBillItem.paidAmount')}
                id="radiology-bill-item-paidAmount"
                name="paidAmount"
                data-cy="paidAmount"
                type="text"
              />
              <ValidatedField
                id="radiology-bill-item-scheduledAt"
                name="scheduledAt"
                data-cy="scheduledAt"
                label={translate('tinyMedicRestApp.radiologyBillItem.scheduledAt')}
                type="select"
              >
                <option value="" key="0" />
                {diaglabEquipments
                  ? diaglabEquipments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="radiology-bill-item-performedBy"
                name="performedBy"
                data-cy="performedBy"
                label={translate('tinyMedicRestApp.radiologyBillItem.performedBy')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="radiology-bill-item-referTo"
                name="referTo"
                data-cy="referTo"
                label={translate('tinyMedicRestApp.radiologyBillItem.referTo')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="radiology-bill-item-diaglabBill"
                name="diaglabBill"
                data-cy="diaglabBill"
                label={translate('tinyMedicRestApp.radiologyBillItem.diaglabBill')}
                type="select"
              >
                <option value="" key="0" />
                {diaglabBills
                  ? diaglabBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="radiology-bill-item-radiologyPricing"
                name="radiologyPricing"
                data-cy="radiologyPricing"
                label={translate('tinyMedicRestApp.radiologyBillItem.radiologyPricing')}
                type="select"
              >
                <option value="" key="0" />
                {radiologyPricings
                  ? radiologyPricings.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="radiology-bill-item-radiologyStudy"
                name="radiologyStudy"
                data-cy="radiologyStudy"
                label={translate('tinyMedicRestApp.radiologyBillItem.radiologyStudy')}
                type="select"
              >
                <option value="" key="0" />
                {radiologyStudies
                  ? radiologyStudies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="radiology-bill-item-scheme"
                name="scheme"
                data-cy="scheme"
                label={translate('tinyMedicRestApp.radiologyBillItem.scheme')}
                type="select"
              >
                <option value="" key="0" />
                {paymentSchemes
                  ? paymentSchemes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/radiology-bill-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RadiologyBillItemUpdate;
